var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pie Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60ZM15 60C15 84.8528 35.1472 105 60 105C84.8528 105 105 84.8528 105 60C105 35.1472 84.8528 15 60 15C35.1472 15 15 35.1472 15 60Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Series 1",
    d: "M60 0C72.6708 1.51097e-07 85.0163 4.0113 95.2671 11.459C105.518 18.9067 113.148 29.4084 117.063 41.459L102.798 46.0942C99.8609 37.0563 94.1385 29.18 86.4503 23.5942C78.7622 18.0085 69.5031 15 60 15V0Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Series 2",
    d: "M117.063 41.459C120.483 51.9827 120.925 63.2471 118.342 74.0067C115.759 84.7663 110.251 94.602 102.426 102.426C94.602 110.251 84.7663 115.759 74.0067 118.342C63.2471 120.925 51.9828 120.483 41.459 117.063L46.0943 102.798C53.9871 105.362 62.4354 105.694 70.5051 103.757C78.5748 101.819 85.9515 97.6881 91.8198 91.8198C97.6881 85.9515 101.819 78.5747 103.757 70.505C105.694 62.4353 105.362 53.9871 102.798 46.0942L117.063 41.459Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Series 3",
    d: "M41.459 117.063C29.4084 113.148 18.9067 105.518 11.459 95.2671L23.5942 86.4503C29.18 94.1385 37.0563 99.8609 46.0942 102.798L41.459 117.063Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Series 4",
    d: "M11.459 95.2671C5.89346 87.6068 2.21992 78.7381 0.738699 69.3861C-0.742519 60.034 0.0106434 50.4642 2.93661 41.459L17.2025 46.0942C15.008 52.8481 14.4431 60.0255 15.554 67.0396C16.6649 74.0536 19.4201 80.7051 23.5942 86.4503L11.459 95.2671Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChart);
export default __webpack_public_path__ + "static/media/empty-chart.27c5529ce3dc2859bb81ba7908eefad6.svg";
export { ForwardRef as ReactComponent };